import {Component, inject, Input, signal} from '@angular/core';
import {IonCol, IonContent, IonGrid, IonRippleEffect, IonRow, ModalController} from '@ionic/angular/standalone';
import {NgIcon} from '@ng-icons/core';
import {ConfigService} from '../../services/config.service';

@Component({
  selector: 'app-share',
  templateUrl: './share.component.html',
  styleUrls: ['./share.component.scss'],
  imports: [NgIcon, IonContent, IonGrid, IonRow, IonCol, IonRippleEffect]
})
export class ShareComponent {

  public modalCtrl = inject(ModalController);
  public configService = inject(ConfigService);

  @Input() url: string;

  canShare = signal<boolean>(false);

  ionViewDidEnter() {
    this.canShare.set(!!(navigator as any).share);
  }

}
